import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { IUserObject } from "../../../../../services/api.types";

interface DeleteEmployeeDialogProps {
  open: boolean;
  employee: IUserObject | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const DeleteEmployeeDialog = ({
  open,
  employee,
  onConfirm,
  onCancel,
  loading = false,
}: DeleteEmployeeDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-employee-dialog-title"
      aria-describedby="delete-employee-dialog-description"
    >
      <DialogTitle id="delete-employee-dialog-title">
        {t("common.confirmDelete")}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t("employees.deleteConfirm", {
            name: `${employee?.firstName ?? ""} ${employee?.lastName ?? ""}`.trim(),
          })}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t("common.actionCannotBeUndone")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" disabled={loading}>
          {t("common.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? t("common.deleting") : t("common.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteEmployeeDialog;
